<template>
  <router-view :model="model" />
</template>

<script>
export default {
  data() {
    return {
      model: {
        orderNo: '',
        orderId: '',
        scheduleId: '',
        scheduleNo: '',
        mediaId: '',
        pageNo: undefined,
        pageSize: 10,
        showType: 0,
        beginDate: undefined,
        endDate: undefined
      },
      currentOrderName: '',
      isFilter: false,
      time: [this.$moment().subtract(30, 'days').format('YYYY-MM-DD'), new Date()],
      orderScheduleNumber: 0,
      scheduleOptions: [],
      mediaOptions: []
    }
  },
  provide() {
    return {
      searchData: this
    }
  },
  watch: {
    model: {
      handler() {
        if (this.$route.params.order) {
          this.isFilter = true
        } else {
          this.isFilter = false
        }
      },
      deep: true
    }
  },
  mounted() {
    this.$bus.$emit('scroll-top')
  }
}

</script>

<style>

</style>
